import { useMemo } from "react";
import { Tag } from "primereact/tag";
import { CustomTable } from "../../../componentes/table/CustomTable";

const STATUS_MAP = {
    PENDENTE: { label: "Pendente", cls: "bg-amber-100 text-amber-700 border border-amber-200" },
    APROVADO: { label: "Aprovado", cls: "bg-success/10 text-success border border-success/30" },
    REJEITADO: { label: "Rejeitado", cls: "bg-destructive/10 text-destructive border border-destructive/30" },
};

function StatusCell({ value }) {
    const s = STATUS_MAP[value] ?? { label: value, cls: "bg-muted text-muted-foreground border border-border" };
    return (
        <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-semibold ${s.cls}`}>
            <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
            {s.label}
        </span>
    );
}

function TabelaAjusteComissao({ data, loading, onRowClick, onCreate, onRetornos }) {

    const columns = useMemo(() => [
        {
            key: "status",
            label: "Status",
            render: (value) => <StatusCell value={value} />
        },
        {
            key: "dataSolicitacao",
            label: "Data Solicitação",
            sortable: true,
            render: (value) => value ? new Date(value).toLocaleString("pt-BR") : "—",
        },
        {
            key: "filialNome",
            label: "Filial",
            sortable: true,
        },
        {
            key: "transporte",
            label: "Transporte",
            sortable: true,
        },
        {
            key: "tipo",
            label: "Tipo Ajuste",
            sortable: true,
            render: (value) => (
                <span className="inline-block rounded bg-blue-50 border border-blue-100 px-2 py-0.5 text-[10px] font-semibold text-blue-700">
                    {value}
                </span>
            ),
        },
        {
            key: "solicitadoPor",
            label: "Solicitado por",
            sortable: true,
            noSelected: true,
        },
    ], []);

    const header = (
        <div className="flex items-center justify-between px-1 py-1 gap-2">
            <button
                onClick={onRetornos}
                className="flex items-center gap-1.5 rounded-lg bg-muted hover:bg-muted/70 text-muted-foreground text-xs font-semibold px-3 py-1.5 transition-colors duration-150 shadow-xs"
            >
                <i className="fa fa-plus text-[10px]" />
                Movimentar Ajustes em Lotes
            </button>
            <button
                onClick={onCreate}
                className="flex items-center gap-1.5 rounded-lg bg-primary hover:brightness-95 text-primary-foreground text-xs font-semibold px-3 py-1.5 transition-colors duration-150 shadow-xs"
            >
                <i className="fa fa-plus text-[10px]" />
                Solicitar ajuste
            </button>
        </div>
    );

    return (
        <CustomTable
            data={data}
            loading={loading}
            header={header}
            columns={columns}
            className="text-[11px]"
            onRowSelect={onRowClick}
            showHeader
            exportFilename="Ajustes de comissoes"
            exportable
            pageSize={20}
            pagination
        />
    );
}

export default TabelaAjusteComissao;
